import React, { Component } from 'react';
import cross from '../../../assets/images/close_popup.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import Upload from '../../shared/PdfUpload';
import '../../../css/termsConditions/TermsConditionsData.css';
import SubmitModal from '../../shared/SuccessModal';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { toast } from 'react-toastify';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { POST_TERMS_AND_CONDITIONS } from '../../../Services/config/apiEndPoints';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
var tncFromServer = ''
class TermsConditionsData extends Component {
  constructor(props) {
    super(props)
    this.container = React.createRef();
    this.state = {
      updateHasOpen: false,
      calendarValue: new Date(),
      isUploadDisabled: false,
      showCalendar: false,
      renderCalendar: false,
      pdfUploadLink: '',
      isEditMode: this.props.isEditMode,
      editValue: this.props.editValue,
      pdfLink: '',
      editEffectiveDate: '',
    }
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleClickOutside);
    console.log(this.state.isEditMode)
    console.log(this.state.editValue)
    if (this.state.isEditMode) {
      tncFromServer = this.props.editValue.termsFile
      this.setState({ editEffectiveDate: this.state.editValue.effectiveFrom })
    }
  }
  removePdfUploadedLink = () => {
    tncFromServer = ''
    this.setState({ pdfUploadLink: '' })
  }
  setPdfUploadLink = (imagePathURL) => {
    this.setState({ pdfUploadLink: imagePathURL })
  }
  validateFormFields = () => {
    return this.state.renderCalendar &&
      this.state.pdfUploadLink.length > 0
  };
  validateEditFormFields = () => {
    return (this.state.pdfUploadLink.length > 0 || tncFromServer.length > 0)
  }
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    if (this.state.calendarValue <= new Date()) {
      formIsValid = false;
      toast(message.validation.futureDate, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
    }
    if (this._isMounted === true) {
      this.setState({ errors: errors });
    }
    return formIsValid;
  }
  handleEditValidation() {
    let errors = {};
    let formIsValid = true;
    let dateString = this.state.editEffectiveDate;
    let dateParts = dateString.split("/");
    let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    if (date < new Date()) {
      formIsValid = false;
      toast(message.validation.futureDate, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
    }
    if (this._isMounted === true) {
      this.setState({ errors: errors });
    }
    return formIsValid;
  }
  handleSubmit = () => {
    if (!this.state.isEditMode) {
      let fromTimeStamp = this.state.calendarValue
      fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(fromTimeStamp).toString().substring(0, 10));
      if (this.handleValidation()) {
        ApiCall(
          'POST',
          baseURL + POST_TERMS_AND_CONDITIONS,
          {
            "creationTime": new Date().getTime(),
            "effectiveFrom": fromTimeStamp,
            "effectiveTo": "",
            "termsFile": this.state.pdfUploadLink,
            "termsId": 0
          },
          {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-cc-trace-id': '1234',
          }
        ).then(data => {
          if (data.flag !== -1) {
            if (data.flag === 500) {
              toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
            else {
              console.log('I am 200!');
              this.setState({ updateHasOpen: true })
            }
          }
          else {
            //  toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
          }
        })
      }
    }
    else {
      if (this.handleEditValidation()) {
        ApiCall(
          'PUT',
          baseURL + POST_TERMS_AND_CONDITIONS,
          {
            "creationTime": 0,
            "effectiveFrom": this.state.editEffectiveDate,
            "effectiveTo": "",
            "termsFile": tncFromServer.length == 0 ? this.state.pdfUploadLink : this.props.editValue.termsFile,
            "termsId": this.state.editValue.termsId
          },
          {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-cc-trace-id': '1234',
          }
        ).then(data => {
          if (data.flag !== -1) {
            if (data.flag === 500) {
              toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
            else {
              console.log('I am 200!');
              this.setState({ updateHasOpen: true })
            }
          }
          else {
            // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
          }
        })
      }
    }
  }
  getDate = (dateString) => {
    //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
    let dateParts = dateString.split("/");
    // month is 0-based, that's why we need dataParts[1] - 1
    let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  onUpdate = () => {
    this.setState({ updateHasOpen: false })
    this.props.onClosePublish()
  }
  toggleMonthCalendar = () => {
    this.setState({ showCalendar: !this.showCalendar, renderCalendar: true });
  }
  handleMonthChanged = (e) => {
    if (this.state.isEditMode) {
      let formatted_date = e.getDate() + "/" + (e.getMonth() + 1) + "/" + e.getFullYear();
      if (e.getDate() <= 9) {
        formatted_date = "0" + formatted_date;
      }
      console.log(formatted_date)
      this.setState({ editEffectiveDate: formatted_date, showCalendar: false })
    }
    else {
      this.setState({
        calendarValue: e, showCalendar: false
      });
    }
  }
  handleClickOutside = event => {
    if (this.container.current && !this.container.current.contains(event.target)) {
      this.setState({ showCalendar: false });
    }
  };
  render() {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let formatted_date = this.state.calendarValue.getDate() + "-" + months[this.state.calendarValue.getMonth()] + "-" + this.state.calendarValue.getFullYear();
    if (this.state.calendarValue.getDate() <= 9) {
      formatted_date = "0" + formatted_date;
    }
    return (
      <div class="termsConditionsModalOuter" >
        <MetaDecorator title={TitleDescription.termsConditionsDataPageTitle} description={TitleDescription.termsConditionsDataPageDescription} />
        <div class="termsConditionsModalInner" >
          <div className='termsConditionsCross'>
            <img src={cross} width="21" height="21" onClick={this.props.onClick} class="d-inlinne-block align-top" alt="" loading="lazy" />
          </div>
          <div class="termsConditionsUpperDiv">
            <small class="termsConditionsHeading">
              Terms & Conditions
            </small>
          </div>
          <div class="termsConditionsMiddleDiv" >
            <div class="termsConditionsMiddleDivOuter">
              <div class="termsConditionsMiddleDivInner">
                <div className="termsConditionsEffectiveDateContainer">
                  <div>
                    <small class="termsConditionsEffectiveDateText">Effective Date</small>
                    <div className="termsConditionsCalendarContainer">
                      {this.state.isEditMode ?
                        <>
                          <div class="termsConditionsInputContainer">
                            <input class="termsConditionsInputBox" placeholder="Select Date"
                              value={this.getDate(this.state.editEffectiveDate)}
                              readOnly></input>
                          </div>
                          <div class="termsConditionsCalendar">  {this.state.showCalendar ? <div ref={this.container}> <Calendar onChange={this.handleMonthChanged} value={this.calendarValue} minDate={new Date()} /></div> : null}</div>
                          <img class="ppl-2 ppr-2" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inlinne-block mr-1 " alt="" loading="lazy" alt=""
                            onClick={this.toggleMonthCalendar}
                          />
                        </>
                        :
                        <>
                          <div class="termsConditionsInputContainer">
                            <input class="termsConditionsInputBox" placeholder="Select Date"
                              value={this.state.renderCalendar ? formatted_date : null}></input>
                          </div>
                          <div class="termsConditionsCalendar">  {this.state.showCalendar ? <div ref={this.container}> <Calendar onChange={this.handleMonthChanged} value={this.calendarValue} minDate={new Date()} /></div> : null}</div>
                          <img class="ppl-2 ppr-2" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inlinne-block mr-1 " alt="" loading="lazy" alt="" onClick={this.toggleMonthCalendar}
                          />
                        </>
                      }
                    </div>
                  </div>
                </div>
                <div class="termsConditionsUploadPdfContainer">
                  <div class="termsConditionsUploadPdfTextContainer">
                    <small class="termsConditionsUploadPdfText">Upload PDF for Terms & Conditions</small>
                  </div>
                  {this.state.isEditMode ? <div class="termsConditionsUploadPdfDiv">
                    <Upload
                      setImageLink={this.setPdfUploadLink}
                      pdfFileName={this.props.editValue.termsFile.includes('https') ? this.props.editValue.termsFile.split('/')[11].split("'")[0] : "termsAndCondotions"}
                      isUploadDisabled={this.props.editValue.termsFile.length > 0 ? true : false}
                      removeLink={this.removePdfUploadedLink}
                    ></Upload>
                  </div>
                    :
                    <div class="termsConditionsUploadPdfDiv">
                      <Upload
                        setImageLink={this.setPdfUploadLink}
                        isUploadDisabled={this.state.isUploadDisabled}
                        removeLink={this.removePdfUploadedLink}
                      ></Upload>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="termsConditionsLowerDiv">
            <button class="termsConditionsConfirmButton"
              disabled={this.props.isEditMode ? !this.validateEditFormFields() : !this.validateFormFields()
              }
              onClick={this.handleSubmit}><small class="termsConditionsButtonText">Confirm</small></button>
          </div>
          <SubmitModal onClick={this.onUpdate} hasOpen={this.state.updateHasOpen} >
            <div className="sectionTexttContainer">
              <p className="sectionTextt">Terms & Conditions has been updated successfully.</p>
            </div>
          </SubmitModal>
        </div>
      </div>
    );
  }
}
export default TermsConditionsData;